import { EntityState } from '@reduxjs/toolkit';

/**
 * Open Natter State Types
 */

// ============================================================================
// Phases
// ============================================================================

export enum OpenNatterPhase {
  Idle = 'IDLE',
  Waiting = 'WAITING',
  ReadyToMatch = 'READY_TO_MATCH',
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED',
  Ended = 'ENDED',
}

// ============================================================================
// Participant
// ============================================================================

export interface Participant {
  id: number;
  name: string;
  role: string;
  avatarLink: string;
  leftRoom?: boolean;
  ready?: boolean; // For waiting room only
}

// ============================================================================
// State Shape
// ============================================================================

export interface OpenNatterState {
  // Phase management
  phase: OpenNatterPhase;

  // Event details
  topic?: string;
  description?: string;
  videos: string[];

  // Timing
  endTime: number; // Unix timestamp (adjusted to client time)
  duration: number; // Minutes
  startingSoon?: 'matched' | 'unmatched';
  serverTimeOffset: number; // Server time - client time (ms), positive if server is ahead

  // Video conference details (Agora)
  accessToken?: string;
  channelName?: string;

  // Participants (entity adapters for normalized state)
  users: EntityState<Participant, number>; // Waiting room users
  matched: EntityState<Participant, number>; // Matched room users

  // UI state
  isReadyToBeMatched: boolean;
  isLoading: boolean;
  isMarkingReady: boolean;

  // Realtime connection state
  isSocketConnected: boolean;
}
